<div class="production-value">
    <span
        class="label">{{ 'service.tickets.details.activityDetails.revisionInfoModal.productionLabel' | translate }}</span>
    : {{
        (info.productionValue != 0 ?
            RevisionUtils.computeRevisionTime(info.planType, info.productionValue, this.unit) + ' ' +
            computeRecurrenceUnit(info) : 'N/A')
    }}
</div>

<app-time-unit-picker [unit]="unit"
                      (selectUnit)="onSelectUnit($event)">
</app-time-unit-picker>

<div class="operations">
    <div class="operation" *ngFor="let operation of info?.operations">
        <div class="name">{{ operation.name }}</div>
        <ng-container *ngIf="operation.recurrences && operation.recurrences.length !=0 else noData" itemBody>
            <div class="recurrence" *ngFor="let recurrence of operation.recurrences">
                <span>{{ this.computeRecurrenceLabel(recurrence) }}</span>
            </div>
        </ng-container>
        <ng-template #noData>
            <span>{{ 'service.tickets.details.activityDetails.revisionInfoModal.noRevisionInfo' | translate }}</span>
        </ng-template>
    </div>
</div>
